import React, { useState, useEffect } from "react";
import { Navbar } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Container from "react-bootstrap/Container";
import "bootstrap/dist/css/bootstrap.min.css";
import "./NavigationBar.css";
import { Timestamp } from "firebase/firestore";
import { fetchImageUrl } from "../Config/firebase";
import Image from "react-bootstrap/Image";
import imagePlaceholder from "../Resources/placeholder.jpg";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";

import { FaEdit } from "react-icons/fa";

import { Card } from "react-bootstrap";

export type GigProps = {
  id: string;
  title: string;
  date: Timestamp;
  image?: string;
  canEdit: boolean;

  imageURL?: string;
};

const ToStringDate = (date: Timestamp) => {
  const dateObject = date.toDate();
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric", // or '2-digit'
    month: "long", // 'short' for abbreviated month name or 'numeric' for number
    day: "numeric", // or '2-digit'
  };
  return dateObject.toLocaleDateString(undefined, options);
};

const ToStringDate2 = (date: Date) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric", // or '2-digit'
    month: "long", // 'short' for abbreviated month name or 'numeric' for number
    day: "numeric", // or '2-digit'
  };
  return date.toLocaleDateString(undefined, options);
};

function Gig(props: GigProps) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);

  useEffect(() => {
    const loadImages = async () => {
      if (props.image) { // Check if image is not undefined
        try {
          console.error("Loading image: ", props.image);
          const url = await fetchImageUrl(props.image);
          console.error("Image URL: ", url);
          setImageUrl(url);
        } catch (error) {
          console.error("Error loading image: ", error);
        }
      }
    };

    loadImages();
  }, []);

  const startEdit = () => {
    // TODO show model edit dialog
  };


  // Helper function to convert Date to string
  function dateToString(date: Date): string {
    return date.toISOString().split("T")[0];
  }

  // Helper function to convert string to Date
  function stringToDate(dateString: string): Date {
    return new Date(dateString);
  }

  return (
    <Card style={{marginBottom: "15px"}}>
      <Card.Header className="d-flex justify-content-between align-items-center">
          <>
            <Card.Title>{props.title}</Card.Title>
            {props.canEdit ? (
              <Card.Subtitle>
                <button
                  onClick={startEdit}
                  className="btn btn-dark"
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "transparent",
                  }}
                >
                  <FaEdit size={20} />
                </button>
              </Card.Subtitle>
            ) : null}
            <Card.Subtitle>{ToStringDate(props.date)}</Card.Subtitle>
          </>
      </Card.Header>

      <Card.Img variant="bottom" src={props.imageURL ? props.imageURL : imageUrl ? imageUrl : imagePlaceholder} />
    </Card>
  );
}

export default Gig;
